export default __webpack_public_path__ + "static/media/eco2.b74e0d60.jpg";